import { Trans } from 'next-i18next'

// FAQ PAGE ARRAY DATA EXAMPLE:
// {
//    title: 'About BASE',
//    list: [
//      {
//        title: 'What is BASE?',
//        description: 'blablabablabla'
//      }, ...
//    ]
// }
const content = (t, i18n) => ({
  title: 'Frequently Asked Questions',
  description:
    'Here you will find the most frequently asked questions (FAQs) about our BASE products.',
  data: [
    {
      title: 'About BASE',
      list: [
        {
          title: t('about-base.what-is-base.title', { ns: 'faq' }),
          description: (
            <>
              <p>{t('about-base.what-is-base.description', { ns: 'faq' })}</p>
            </>
          ),
        },
        // {
        //   title: "What is a personalized skincare?",
        //   description: (
        //     <>
        //       IA personalized skincare is a skincare that is formulated based on your skin condition and lifestyle. In BASE we use an algorithm to better target your skin problem with the right ingredient.
        //     </>
        //   ),
        // },
        {
          title: t('about-base.product-unique.title', { ns: 'faq' }),
          description: (
            <>
              <p>
                {t('about-base.product-unique.description-1', { ns: 'faq' })}
              </p>
              <p>
                {t('about-base.product-unique.description-2', { ns: 'faq' })}
              </p>
            </>
          ),
        },
      ],
    },
    {
      title: 'BASE Products',
      list: [
        {
          title: t('base-product.1.title', { ns: 'faq' }),
          description: t('base-product.1.description', { ns: 'faq' }),
        },
        {
          title: t('base-product.2.title', { ns: 'faq' }),
          description: t('base-product.2.description', { ns: 'faq' }),
        },
        {
          title: t('base-product.3.title', { ns: 'faq' }),
          description: t('base-product.3.description', { ns: 'faq' }),
        },
        {
          title: t('base-product.4.title', { ns: 'faq' }),
          description: t('base-product.4.description', { ns: 'faq' }),
        },
        {
          title: t('base-product.5.title', { ns: 'faq' }),
          description: t('base-product.5.description', { ns: 'faq' }),
        },
        {
          title: t('base-product.6.title', { ns: 'faq' }),
          description: t('base-product.6.description', { ns: 'faq' }),
        },
        {
          title: t('base-product.7.title', { ns: 'faq' }),
          description: (
            <>
              {t('base-product.7.content.1', { ns: 'faq' })}
              <ol>
                <li>{t('base-product.7.content.2.a', { ns: 'faq' })}</li>
                <li>{t('base-product.7.content.2.b', { ns: 'faq' })}</li>
              </ol>
              <Trans i18n={i18n} ns="faq" i18nKey={'base-product.7.content.3'}>
                <a
                  target="blank"
                  href="https://www.base.co.id/blog/the-right-way-to-layer-your-skincare-product"
                ></a>
              </Trans>
            </>
          ),
        },
        {
          title: 'When can I expect to see results?',
          description:
            'Results may vary depend on your lifestyle and some external factors. However, based on the cell-turnover rate, expect results in 40-56 days when used regularly morning and night.',
        },
      ],
    },
    {
      title: 'Skin Test',
      list: [
        {
          title: t('skin-test.1.title', { ns: 'faq' }),
          description: (
            <>
              <p>{t('skin-test.1.description.1', { ns: 'faq' })}</p>
              <p>{t('skin-test.1.description.2', { ns: 'faq' })}</p>
            </>
          ),
        },
        {
          title: t('skin-test.2.title', { ns: 'faq' }),
          description: t('skin-test.2.description', { ns: 'faq' }),
        },
        {
          title: t('skin-test.3.title', { ns: 'faq' }),
          description: t('skin-test.3.description', { ns: 'faq' }),
        },
      ],
    },
    {
      title: t('order-and-payment.main-title', { ns: 'faq' }),
      list: [
        {
          title: t('order-and-payment.1.title', { ns: 'faq' }),
          description: (
            <ol>
              <li>{t('order-and-payment.1.description.1', { ns: 'faq' })}</li>
              <li>{t('order-and-payment.1.description.2', { ns: 'faq' })}</li>
              <li>{t('order-and-payment.1.description.3', { ns: 'faq' })}</li>
              <li>{t('order-and-payment.1.description.4', { ns: 'faq' })}</li>
              <li>{t('order-and-payment.1.description.5', { ns: 'faq' })}</li>
            </ol>
          ),
        },
        {
          title: t('order-and-payment.2.title', { ns: 'faq' }),
          description: (
            <>
              <p>
                <Trans
                  i18n={i18n}
                  ns="faq"
                  i18nKey={'order-and-payment.2.description.1'}
                >
                  <a target="blank" href="https://www.base.co.id/products"></a>
                  <a
                    target="blank"
                    href="https://www.base.co.id/quiz/intro"
                  ></a>
                </Trans>
              </p>
              <p>{t('order-and-payment.2.description.2', { ns: 'faq' })}</p>
            </>
          ),
        },
        {
          title: t('order-and-payment.3.title', { ns: 'faq' }),
          description: (
            <>
              <p>{t('order-and-payment.3.description.main', { ns: 'faq' })}</p>
              <ol>
                <li>{t('order-and-payment.3.description.1', { ns: 'faq' })}</li>
                <li>{t('order-and-payment.3.description.2', { ns: 'faq' })}</li>
                <li>{t('order-and-payment.3.description.3', { ns: 'faq' })}</li>
                <li>{t('order-and-payment.3.description.4', { ns: 'faq' })}</li>
              </ol>
            </>
          ),
        },
        {
          title: t('order-and-payment.4.title', { ns: 'faq' }),
          description: (
            <>
              <p>{t('order-and-payment.4.description.main', { ns: 'faq' })}</p>
              <ol>
                <li>{t('order-and-payment.4.description.1', { ns: 'faq' })}</li>
                <li>{t('order-and-payment.4.description.2', { ns: 'faq' })}</li>
                <li>{t('order-and-payment.4.description.3', { ns: 'faq' })}</li>
                <li>{t('order-and-payment.4.description.4', { ns: 'faq' })}</li>
                <li>{t('order-and-payment.4.description.6', { ns: 'faq' })}</li>
                <li>{t('order-and-payment.4.description.7', { ns: 'faq' })}</li>
              </ol>
            </>
          ),
        },
      ],
    },
    {
      title: t('shipping.main-title', { ns: 'faq' }),
      list: [
        {
          title: t('shipping.1.title', { ns: 'faq' }),
          description: t('shipping.1.description', { ns: 'faq' }),
        },
        {
          title: t('shipping.2.title', { ns: 'faq' }),
          description: t('shipping.2.description', { ns: 'faq' }),
        },
        {
          title: t('shipping.3.title', { ns: 'faq' }),
          description: t('shipping.3.description', { ns: 'faq' }),
        },
        {
          title: t('shipping.4.title', { ns: 'faq' }),
          description: t('shipping.4.description', { ns: 'faq' }),
        },
        {
          title: t('shipping.5.title', { ns: 'faq' }),
          description: t('shipping.5.description', { ns: 'faq' }),
        },
        {
          title: t('shipping.6.title', { ns: 'faq' }),
          description: t('shipping.6.description', { ns: 'faq' }),
        },
      ],
    },
    {
      title: t('refund-return-policy.main-title', { ns: 'faq' }),
      list: [
        {
          title: t('refund-return-policy.1.title', { ns: 'faq' }),
          description: [
            <>
              <Trans
                i18n={i18n}
                ns="faq"
                i18nKey={'refund-return-policy.1.description.1'}
              >
                <b />
              </Trans>
              <p>
                {t('refund-return-policy.1.description.2.main', { ns: 'faq' })}
              </p>
              <ol>
                <li>
                  {t('refund-return-policy.1.description.2.a', { ns: 'faq' })}
                </li>
                <li>
                  {t('refund-return-policy.1.description.2.b', { ns: 'faq' })}
                </li>
                <li>
                  {t('refund-return-policy.1.description.2.c', { ns: 'faq' })}
                </li>
              </ol>
            </>,
          ],
        },
        {
          title: t('refund-return-policy.2.title', { ns: 'faq' }),
          description: t('refund-return-policy.2.description', { ns: 'faq' }),
        },
        {
          title: t('refund-return-policy.3.title', { ns: 'faq' }),
          description: t('refund-return-policy.3.description', { ns: 'faq' }),
        },
      ],
    },
    {
      title: 'Gift Card',
      list: [
        {
          title: t('gift-card.1.title', { ns: 'faq' }),
          description: [
            <>
              <p>{t('gift-card.1.description.main', { ns: 'faq' })}</p>
              <ol>
                <li>{t('gift-card.1.description.1', { ns: 'faq' })}</li>
                <li>{t('gift-card.1.description.2', { ns: 'faq' })}</li>
                <li>{t('gift-card.1.description.3', { ns: 'faq' })}</li>
              </ol>
            </>,
          ],
        },
        {
          title: t('gift-card.2.title', { ns: 'faq' }),
          description: t('gift-card.2.description', { ns: 'faq' }),
        },
        {
          title: t('gift-card.3.title', { ns: 'faq' }),
          description: t('gift-card.3.description', { ns: 'faq' }),
        },
        {
          title: t('gift-card.4.title', { ns: 'faq' }),
          description: t('gift-card.4.description', { ns: 'faq' }),
        },
        {
          title: t('gift-card.5.title', { ns: 'faq' }),
          description: t('gift-card.5.description', { ns: 'faq' }),
        },
      ],
    },
    // {
    //   title: 'How it works?',
    //   list: [
    //     {
    //       title: 'How to order BASE Personalized Skincare?',
    //       description: (
    //         <>
    //         Follow these 3 easy steps, and get your Personalized Skincare in no time!
    //           <ol>
    //             <li>First, complete your skin test <a target='blank' href='https://www.base.co.id/quiz/intro'>here</a></li>
    //             <li>After getting your skin analysis and your recommended ingredients, choose your Personalized Skincare products.</li>
    //             <li>Lastly, proceed to checkout and relax until your Personalized Skincare arrived!</li>
    //             <li><a target="blank" href='https://www.base.co.id/blog/miliki-base-personalized-skincare-dengan-3-langkah-mudah' >Click here</a> to find more information about how to order BASE Personalized Skincare.</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: "Can I order without skin test?",
    //       description: (
    //         <>
    //           You can’t order without completing the skin test. The skin test is important for you and us to formulate which ingredients are best to target your skin concerns so, you don’t have to try many products before finding the right one.
    //         </>
    //       ),
    //     },
    //     {
    //       title: "How does BASE formulate my skincare?",
    //       description: (
    //         <>
    //           <p>BASE uses an algorithm to find the best and the most effective ingredient to target your skin concerns. Our algorithm formulate your ingredients according to your age, skin type, skin concern, and your lifestyle that includes your sleeping habit to how you commute.</p>
    //           <p>We will keep updating and improving our algorithm based on the feedback and survey gathered from our users regarding the product safety and efficacy. We will do a continuous research and development to better suit your skin’s need as your skin will change along the time</p>
    //         </>
    //       ),
    //     },
    //     {
    //       title: "What is Hero Ingredients?",
    //       description: (
    //         <>
    //           Hero Ingredients are the term we use to describe the active ingredients on your formula. You can see your hero ingredients after completing the skin test.
    //         </>
    //       ),
    //     },
    //     {
    //       title: "Can I request to take out or add more active ingredients that is not listed on my recommended ingredient list?",
    //       description: (
    //         <>
    //           Since your formula is personalized based on the algorithm, we cannot take out or add more ingredients on request. You can give feedbacks about BASE’s product by sending us email to hello@base.co.id.
    //         </>
    //       ),
    //     },
    //     {
    //       title: "Can I request to make my own formula?",
    //       description: (
    //         <>
    //           In the mean time, we are not able to fulfill your request. Our smart algorithm will tell you which active ingredients that are effective on targeting your skin concerns.
    //         </>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   title: 'My Account',
    //   list: [
    //     {
    //       title: 'Do I have create account to purchase BASE products? ',
    //       description: 'Yes, we will require you to create an account to purchase BASE products. This account will be used to store your orders, invoices, shipping and billing history.',
    //     },
    //     {
    //       title: 'How can I change my personal data?',
    //       description: (
    //         <>
    //           Follow this easy-peasy steps:
    //           <ol>
    //             <li><strong>Log in</strong> to our website with your registered account details</li>
    //             <li>Click the <strong>menu button</strong> on top right corner of the page</li>
    //             <li>Click <strong>Account Details</strong></li>
    //             <li>Click <strong>Edit Profile</strong></li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: "I haven't logged on to my account at BASE for quite some time, can I still access my skin analysis result?",
    //       description: 'If you already have a registered account on our website, you can just sign in anytime to see your skin analysis results.',
    //     },
    //   ],
    // },
    // {
    //   title: 'Shipping',
    //   list: [
    //     {
    //       title: 'How long does my personalized skincare take to arrive?',
    //       description: 'We will process your order in 3-5 business days for Jabodetabek area, and 5-10 business days for area outside Jabodetabek.',
    //     },
    //     {
    //       title: 'Do you ship worldwide?',
    //       description: 'We are on a process to expand our shipment internationally, yay! For now, please reach us by email at hello@base.co.id with “International Shipping” as your subject email.',
    //     },
    //     {
    //       title: 'Do you ship nationwide?',
    //       description: "Yes! We shipped nationwide from Sabang to Merauke without fees. In other words, it’s FREE DELIVERY!",
    //     },
    //     {
    //       title: 'How to track my order?',
    //       description: (
    //         <>
    //           You need to log in to www.base.co.id and then go to your BASE profile and select <b>“Your Order”</b> to track your order.
    //         </>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   title: 'Payment Methods - How to Pay',
    //   list: [
    //     {
    //       title: 'Can I cancel my order after completing payment?',
    //       description: 'You can’t cancel your order after completing payment.',
    //     },
    //     {
    //       title: 'What payment methods do you accept?',
    //       description: (
    //         <>
    //           We accept all payment methods as listed below;
    //           <ol>
    //             <li>Online Debit Card.</li>
    //             <li>Online Credit Card, such as Visa, MasterCard, and JCB.</li>
    //             <li>Virtual Account, such as BCA, BRI, BNI, Permata, and Mandiri.</li>
    //             <li>Digital Wallet, such as GO-PAY, OVO, DANA and ShopeePay.</li>
    //             <li>Manual Bank Transfer</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'Do you have any other currency?',
    //       description: 'Right now, we only accept Rupiah as our main currency for transaction.',
    //     },
    //     {
    //       title: 'How to do the payment using Virtual Account?',
    //       description: (
    //         <>
    //           <h3>BCA Virtual Account :</h3>
    //           <ul>
    //             <li>
    //               <strong>ATM BCA</strong>
    //               <ol>
    //                 <li>Insert your ATM card and BCA PIN.</li>
    //                 <li>On the main menu, select the &quot;Other transactions&quot; menu.</li>
    //                 <li>Select the &quot;Transfer&quot; menu and then select &quot;BCA Virtual Account&quot;.</li>
    //                 <li>Enter no. BCA Virtual Account &amp; click &quot;Continue&quot;.</li>
    //                 <li>Double check your payment details, then select Yes.</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>Klik BCA</strong>
    //               <ol>
    //                 <li>Login to the KlikBCA application, enter your user ID &amp; PIN.</li>
    //                 <li>Select &quot;Funds Transfer&quot;, then select &quot;Transfer to BCA Virtual Account&quot;.</li>
    //                 <li>Enter no.BCA Virtual Account &amp; click &quot;Continue&quot;.</li>
    //                 <li>Make sure the data entered is correct, and Input &quot;KeyBCA Response&quot;, then click &quot;Send&quot;.</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>M-BCA</strong>
    //               <ol>
    //                 <li>Log in to the BCA mobile application.</li>
    //                 <li>Select &quot;m-BCA&quot;, enter the m-BCA access code.</li>
    //                 <li>Select &quot;m-Transfer&quot;.</li>
    //                 <li>Select &quot;BCA Virtual Account&quot;.</li>
    //                 <li>Enter the BCA Virtual Account number and click &quot;OK&quot;.</li>
    //                 <li>Confirm virtual account number and debit account</li>
    //                 <li>Check your payment details, then click &quot;Yes&quot;</li>
    //                 <li>Enter the m-BCA pin.</li>
    //                 <li>Payment complete.</li>
    //               </ol>
    //               <br />
    //             </li>
    //           </ul>
    //           <h3>Mandiri Virtual Account :</h3>
    //           <ul>
    //             <li>
    //               <strong>ATM Mandiri</strong>
    //               <ol>
    //                 <li>Enter your ATM PIN.</li>
    //                 <li>In the main menu, select the &quot;Pay / Buy&quot; menu then select the &quot;Multi Payment&quot; menu (If the screen is not available yet, press the &quot;Other&quot; menu and select &quot;Multi Payment&quot;).</li>
    //                 <li>Enter the number 70012 in the company code then press the &quot;Correct&quot; button.</li>
    //                 <li>Enter payment code (your Mandiri bill payment code)</li>
    //                 <li>Double-check your transaction data and complete the payment process.</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>Mandiri Internet Banking</strong>
    //               <ol>
    //                 <li>Login to your Mandiri Internet Banking.</li>
    //                 <li>On the main menu, select the &quot;Pay&quot; menu then select the &quot;Multi Payment&quot; menu.</li>
    //                 <li>Select your account in the From Account section, then in the Service Provider select &quot;PT Basis Inovasi Global&quot;.</li>
    //                 <li>Enter the payment code (your Mandiri bill payment method), and click &quot;Continue&quot;.</li>
    //                 <li>Double-check your company name, order number and payment amount.</li>
    //                 <li>Complete payment using Mandiri Token.</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>Mandiri Online</strong>
    //               <ol>
    //                 <li>Login to your Mandiri Online.</li>
    //                 <li>On the main menu, select the &quot;Pay&quot; menu.</li>
    //                 <li>Then select the &quot;Multi Payment&quot; menu.</li>
    //                 <li>Select Service Provider &quot;PT Basis Inovasi Global&quot;.</li>
    //                 <li>Enter the payment code [Mandiri bill payment code], and click &quot;Continue&quot;.</li>
    //                 <li>Double-check your transaction data and complete the payment process.</li>
    //               </ol>
    //               <br />
    //             </li>
    //           </ul>
    //           <h3>BNI Virtual Account :</h3>
    //           <ul>
    //             <li>
    //               <strong>ATM BNI</strong>
    //               <ol>
    //                 <li>Insert your BNI ATM card and PIN</li>
    //                 <li>In the main menu, select the &quot;Other Menu&quot; &gt; &quot;Transfer&quot; &gt; &quot;Savings Account&quot; &gt; to &quot;BNI Account&quot;</li>
    //                 <li>Enter the Virtual Account number.</li>
    //                 <li>Enter the payment amount according to the bill</li>
    //                 <li>On the confirmation page, make sure the transaction data is correct then select &quot;Yes&quot;</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>Mobile Banking BNI</strong>
    //               <ol>
    //                 <li>Access BNI Mobile Banking via mobile</li>
    //                 <li>Enter your User ID and Password</li>
    //                 <li>Select the &quot;Transfer&quot; menu, then select &quot;Between BNI Accounts&quot;, select &quot;New Account Input&quot;</li>
    //                 <li>Enter the Virtual Account number</li>
    //                 <li>On the confirmation page, make sure the transaction data is correct then select &quot;Yes&quot;</li>
    //                 <li>Enter your password</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>Internet Banking BNI</strong>
    //               <ol>
    //                 <li>Enter <a href="https://ibank.bni.co.id" target="blank">https://ibank.bni.co.id</a></li>
    //                 <li>Enter your User ID and Password</li>
    //                 <li>Select the &quot;Transfer&quot; menu, then select &quot;Add Favorite Account&quot;.If using a Desktop.add accounts in the &quot;Transaction&quot; menu then &quot;Set Destination Account&quot; then select &quot;Add Destination Account&quot;</li>
    //                 <li>Enter the Virtual Account number</li>
    //                 <li>Enter the Authentication Code and the Account Number has been successfully added</li>
    //                 <li>Select the &quot;Transfer&quot; menu, then select &quot;Transfer Between BNI Accounts&quot;, select &quot;Destination Account&quot;</li>
    //                 <li>Select the Debit Account</li>
    //                 <li>Enter the payment amount according to the bill</li>
    //                 <li>Enter the Authentication Code</li>
    //               </ol>
    //               <br />
    //             </li>
    //           </ul>
    //           <h3>BRI Virtual Account :</h3>
    //           <ul>
    //             <li>
    //               <strong>ATM BRI</strong>
    //               <ol>
    //                 <li>Insert your ATM card and BRI PIN</li>
    //                 <li>On the main menu, select the menu &quot;Other Transactions&quot; &gt; &quot;Payment&quot; &gt; &quot;Other&quot; &gt; &quot;BRIVA&quot;</li>
    //                 <li>Enter the BRIVA number</li>
    //                 <li>On the confirmation page, make sure the transaction data is correct then select &quot;Yes&quot;</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>Mobile Banking BRI</strong>
    //               <ol>
    //                 <li>Access BRI Mobile Banking via mobile</li>
    //                 <li>Select &quot;BRI Mobile Banking&quot;</li>
    //                 <li>Select the &quot;Info&quot; menu, then select &quot;BRIVA&quot;</li>
    //                 <li>Enter the BRIVA number</li>
    //                 <li>Enter the payment amount according to the bill</li>
    //                 <li>Enter your PIN</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>Internet Banking BRI</strong>
    //               <ol>
    //                 <li>Login to <a href="https://ib.bri.co.id/ib-bri/" target="blank">https://ib.bri.co.id/ib-bri/</a></li>
    //                 <li>Enter your Username and Password</li>
    //                 <li>Select the &quot;Payment&quot; menu, then select &quot;BRIVA&quot;</li>
    //                 <li>Enter the BRIVA number</li>
    //                 <li>Make sure the transaction data is correct</li>
    //                 <li>Enter your password</li>
    //                 <li>Enter your mToken</li>
    //               </ol>
    //               <br />
    //             </li>
    //           </ul>
    //           <h3>Permata Virtual Account :</h3>
    //           <ul>
    //             <li>
    //               <strong>ATM Permata</strong>
    //               <ol>
    //                 <li>Insert your ATM card and Permata PIN</li>
    //                 <li>Choose &quot;Other Transaction&quot;.</li>
    //                 <li>Choose &quot;Payment Transaction&quot;.</li>
    //                 <li>Choose &quot;Others&quot;.</li>
    //                 <li>Choose &quot;Virtual Account Payment&quot;.</li>
    //                 <li>Insert 16 digit Virtual Account number.</li>
    //                 <li>Press &quot;Yes&quot; for confirmation.</li>
    //                 <li>Choose account that will be used for payment.</li>
    //               </ol>
    //               <br />
    //             </li>
    //             <li>
    //               <strong>Mobile Banking Permata</strong>
    //               <ol>
    //                 <li>Insert your User ID and Password, then click ‘Login’ button</li>
    //                 <li>Choose &quot;Bill Payment&quot;.</li>
    //                 <li>Select the category &quot;Virtual Account&quot;.</li>
    //                 <li>Select the bank account (if customer have more than one bank account).</li>
    //                 <li>Input 16 (sixteen) digit Virtual Account number and total payment.</li>
    //                 <li>Click &quot;Confirm&quot; button and automatically you will recieve the &quot;Challenge Code&quot;.</li>
    //                 <li>Insert &quot;Challenge Code&quot;, then click &quot;Confirm&quot; button.</li>
    //               </ol>
    //               <br />
    //             </li>
    //           </ul>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'How to do the payment using Credit Card?',
    //       description: (
    //         <>
    //           <ol>
    //             <li>Select Credit Card as the payment method</li>
    //             <li>Input 16 digit card number</li>
    //             <li>Input your card’s expiry date</li>
    //             <li>Input CVV number: The 3 digit secret number that is on the back of the card</li>
    //             <li>OTP code will be sent to your phone number to verify the transaction</li>
    //             <li>Input OTP code to proceed with the payment</li>
    //             <li>Check to see if your payment is successful</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'How to do the payment using Bank Transfer?',
    //       description: (
    //         <>
    //           <ol>
    //             <li>Select Bank Transfer as Payment Method</li>
    //             <li>Choose &quot;See Transfer Details&quot;</li>
    //             <li>Input our BCA Bank Account Number 0060686955 - PT Basis Inovasi Global</li>
    //             <li>Input Bank Code: 014 if you transfer from other bank</li>
    //             <li>Input Total Payment Amount</li>
    //             <li>Please don&apos;t forget to input Your Order ID number in Berita Transfer or Referensi</li>
    //             <li>After your payment is success, please upload your payment proof through the button below or log-in to your BASE account.</li>
    //             <li>BASE Team will immediately contact you for your success transfer/payment confirmation,  if you input the wrong amount or details we can assist you from there.</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'How to do the payment using GO-PAY?',
    //       description: (
    //         <>
    //           <ol>
    //             <li>Select GO-PAY as Payment Method</li>
    //             <li>
    //               Proceed with payment by using one of the following:
    //               <ul>
    //                 <li>Scan the QR Code using GO-PAY application to proceed with the payment confirmation, <strong>or</strong></li>
    //                 <li>Click the link to Open GO-JEK application to proceed with the payment confirmation</li>
    //               </ul>
    //             </li>
    //             <li>Go to Your Order menu in our website to see if your payment is successful</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'How to do the payment using OVO?',
    //       description: (
    //         <>
    //           <ol>
    //             <li>Select OVO as Payment Method.</li>
    //             <li>Input your OVO registered phone number</li>
    //             <li>Open your OVO application</li>
    //             <li>Proceed to confirm the payment from PT Basis Inovasi Global</li>
    //             <li>Go to Your Order menu in our website to see if your payment is successful</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'How to do the payment using DANA?',
    //       description: (
    //         <>
    //           <ol>
    //             <li>Select DANA as your Payment Method</li>
    //             <li>Input your DANA registered phone number</li>
    //             <li>Open your DANA application</li>
    //             <li>Proceed to confirm the payment from PT Basis Inovasi Global</li>
    //             <li>Choose Pay and input your PIN</li>
    //             <li>Go to Your Order menu in our website to see if your payment is successful</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'How to pay using ShopeePay via mobile?',
    //       description: (
    //         <>
    //         For now, ShopeePay payment method can only be accessed on mobile phone.
    //           <ol>
    //             <li>Select ShopeePay as your Payment Method on your mobile phone</li>
    //             <li>You will be redirected to Shopee application</li>
    //             <li>Make sure the transaction details are correct and click Continue</li>
    //             <li>If you have ShopeePay Voucher, choose the Voucher then click OK to proceed</li>
    //             <li>Click Pay Now and input your ShopeePay PIN</li>
    //             <li>You will receive a notification when the payment is successful.</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   title: 'Voucher & Coupon Code Usage',
    //   list: [
    //     {
    //       title: 'How to redeem a coupon code?',
    //       description: (
    //         <>
    //           Follow these 3 steps to redeem your coupon;
    //           <ol>
    //             <li>Complete the skin test</li>
    //             <li>Choose the personalized skincare products and then proceed to checkout. </li>
    //             <li>Enter you COUPON CODE in the box below the total price</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'Why can’t I redeem a coupon code?',
    //       description: 'If you have difficulties on redeeming a coupon code, feel free to contact BASE Pal through WhatsApp 081808110888. We will be happy to help.',
    //     },
    //     {
    //       title: 'Do you have a first buyer discount?',
    //       description: 'Yes, after completing skin test you will get an email with a coupon code inside. Can’t find it? Try checking your SPAM box.',
    //     },
    //     {
    //       title: 'Can I use a multiple coupon codes in one order?',
    //       description: 'You can only use 1 (one) coupon code in each order. ',
    //     },
    //   ],
    // },
    // {
    //   title: 'Gift Card',
    //   list: [
    //     {
    //       title: 'How to buy BASE Gift Card?',
    //       description: (
    //         <>
    //           Send a personalized Gift Card digitally in 3-easy-steps;
    //           <ol>
    //             <li>Choose Gift Card based on the occasion and confirm the amount of the Gift Card.</li>
    //             <li>Then, fill the recipient’s details. You can add your personal message and schedule the delivery date in advance.</li>
    //             <li>Proceed to payment. You will get one email paid order confirmation and another email when the Gift Card has been sent to the recipient.</li>
    //           </ol>
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'Do you have physical gift card?',
    //       description: 'For now, we do not have physical gift card.',
    //     },
    //     {
    //       title: 'Does Gift Card has expiration date?',
    //       description: 'Gift Card does not have expiration date.',
    //     },
    //     {
    //       title: 'Can I add a message along with the Gift Card?',
    //       description: 'Yes, you can add your message at the next step after clicking ‘CONTINUE’',
    //     },
    //     {
    //       title: 'When and what time will my Gift Card be emailed?',
    //       description: 'You can schedule a Gift Card in advance. Gift Card that has been scheduled will be emailed in the morning at 07.00 WIB (West Indonesia Time)',
    //     },
    //     {
    //       title: 'Can I reschedule the Gift Card delivery date?',
    //       description: 'Yes, contact us via WhatsApp 081808110888 to reschedule the delivery date.',
    //     },
    //     {
    //       title: 'Is it refundable?',
    //       description: 'Gift Card that has been sent cannot be refunded, but if you have any difficulties feel free to reach us via WhatsApp 081808110888',
    //     },
    //     {
    //       title: 'Recipient didn’t receive the Gift Card?',
    //       description: 'Make sure it didn’t get into SPAM box. If recipient cannot find it, please contact us via WhatsApp for further notice.',
    //     },
    //     {
    //       title: 'What happen if the recipient’s email is inactive?',
    //       description: 'Reach us out via WhatsApp 081808110888',
    //     },
    //   ],
    // },
    // {
    //   title: 'Returns and Refund Policy',
    //   list: [
    //     {
    //       title: 'What your return or refund policy?',
    //       description: (
    //         <>
    //           We take full responsibility for damaged or defective products, including covering the return shipment fees. You can also choose to return or request a refund for your personalized skincare, if you experience one of the following;
    //           <ul>
    //             <li>You received leaked or damage bottle.</li>
    //             <li>You received contaminated products, like fungi or lumps inside.</li>
    //             <li>You encounter a negative reaction after using BASE products.</li>
    //           </ul>
    //           Any issues must be reported to BASE Pal immediately within 7 business days from the date you received BASE Products. Remember to reach us if you wish to return or refund your product.
    //         </>
    //       ),
    //     },
    //     {
    //       title: 'What to do if I experience negative reaction after using BASE products?',
    //       description: 'If you experience negative reaction, such as irritation, burning sensations, itchiness or redness after using BASE product please reach BASE Pal immediately within 7 days from the day your product arrived.',
    //     },
    //     {
    //       title: 'What to do if I haven’t received the products?',
    //       description: 'Please reach out to us if you haven’t received any notice for 10 days after completing payment.',
    //     },
    //     {
    //       title: 'What to do if I want to change my shipping address?',
    //       description: 'You may reach us via WhatApps about your new address.',
    //     },
    //     {
    //       title: 'How long does the return and refund process take?',
    //       description: 'After reporting the issues to BASE Pal, our Product Team will assess your request. All the process will take about 10-15 business days.',
    //     },
    //   ],
    // },
  ],
})

export default content
